"use client"
import type React from "react"
import { useEffect, useState, useRef } from "react"
import Image from "next/image"
import axios from "axios"
import { BASE_URL } from "@/util/api"
import { Pagination } from "antd"
import Link from "next/link"
import { ChevronLeft, ChevronRight } from "lucide-react"
import NewsLetter from "@/components/serviceComponent/newsLetter"
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"
import toast from "react-hot-toast"
import { GoArrowRight } from "react-icons/go"
import Button from '@/components/CommonComponent/button'
const Blogs = () => {
  const [blogs, setBlogs] = useState<any>(null)
  const [allBlogs, setAllBlogs] = useState<any>([])
  const [searchQuery, setSearchQuery] = useState("")
  const [pages, setPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [recentblogs, setrecentblogs] = useState<any>()
  const menuRef = useRef<HTMLUListElement>(null)
  const [category, setcategory] = useState<any>(null)
  const [featured, setfeatured] = useState<any>([])
  const sectionRef = useRef<HTMLDivElement | null>(null)

  const fetchBlogs = async (page = 1, query = "") => {
    try {
      const url = query ? `${BASE_URL}blogs/?page=${page}&search=${query}` : `${BASE_URL}blogs/?page=${page}`
      const response = await axios.get(url)
      setBlogs(response.data)
      setAllBlogs(response.data.results.blogs)
      const totalPages = Math.ceil(response.data.count / 10) // Assuming 10 blogs per page
      setPages(totalPages)
    } catch (error: any) {
      // //console.error('Error fetching blogs:', error.message);
    }
  }

  const fetchrecentBlogs = async (page = 1) => {
    try {
      const response = await axios.get(`${BASE_URL}blogs/?page=1`)
      setrecentblogs(response?.data?.results?.recent_blogs)
      setfeatured(response?.data?.results?.favourite_blogs)
      setcategory(response?.data?.results?.categories)
    } catch (error: any) {
      // //console.error('Error fetching recent blogs:', error.message);
    }
  }
  useEffect(() => {
    fetchBlogs(currentPage, searchQuery) // Fetch blogs based on search query
  }, [currentPage, searchQuery]) // Dependency array includes currentPage and searchQuery
  useEffect(() => {
    fetchrecentBlogs() // Fetch recent blogs on component mount
  }, [])

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value) // Update search query on input change
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page) // Update the current page on pagination change
    sectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center", // Align to the start of the section
    })
  }

  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const [scrolled, setScrolled] = useState(false);

  const scrollMenu = (direction: "left" | "right") => {
    if (menuRef.current) {
      menuRef.current.scrollBy({
        left: direction === "left" ? -250 : 250, // Adjust for smoother scrolling
        behavior: "smooth",
      })
    }
  }

  // Check if scrolling is possible and update button visibility
  const checkScrollability = () => {
    if (menuRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = menuRef.current
      setCanScrollLeft(scrollLeft > 0)
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1) // -1 for rounding errors
    }
  }

  // Initial check and add event listeners
  useEffect(() => {
    // Force an initial check after a short delay to ensure content is rendered
    const timer = setTimeout(() => {
      checkScrollability()
    }, 100)

    // Add scroll event listener
    menuRef.current?.addEventListener("scroll", checkScrollability)

    // Add resize listener to handle window size changes
    window.addEventListener("resize", checkScrollability)

    return () => {
      clearTimeout(timer)
      menuRef.current?.removeEventListener("scroll", checkScrollability)
      window.removeEventListener("resize", checkScrollability)
    }
  }, [blogs?.results?.category]) // Re-run when categories change
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  useEffect(() => {
    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const [message, setMessage] = useState({
    name: "",
    email: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });

  // Regex for validation
  const nameRegex = /^[a-zA-Z\s]+$/; // Only A-Z and spaces
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Email pattern

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setMessage({ ...message, [name]: value });

    // Validation
    if (name === "name") {
      setErrors({ ...errors, name: nameRegex.test(value) ? "" : "Only A-Z characters allowed" });
    } else if (name === "email") {
      setErrors({ ...errors, email: emailRegex.test(value) ? "" : "Invalid email format" });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Final validation before submission
    if (!message.name || !nameRegex.test(message.name)) {
      setErrors((prev) => ({ ...prev, name: "Only A-Z characters allowed" }));
      return;
    }
    if (!message.email || !emailRegex.test(message.email)) {
      setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
      return;
    }

    try {
      await axios.post(`${BASE_URL}subscription/`, message);
      toast.success("Message sent successfully");
      setMessage({ name: "", email: "" });
      setErrors({ name: "", email: "" }); // Clear errors after successful submit
    } catch (error: any) {
      toast.error(error?.response?.data?.email || "Something went wrong!");
    }
  };
  // console.log('blogs',blogs)
  return (
    <div>
      <div className="w-full relative">
        <div className={` top-10 lg:top-4 z-50 pt-5 ${scrolled ? '' : 'bg-[#DFF1F9]'}`}>
          {blogs?.results?.category && blogs?.results?.category.length > 0 && (
            <div className="top-16 sticky z-50 w-fit max-w-[95%] lg:max-w-[75%] xl:w-[60%] 2xl:max-w-[55%] mx-auto mt-6 ">
              {/* Left Scroll Button - Always render but control visibility with opacity */}
              <button
                onClick={() => scrollMenu("left")}
                className={`absolute left-0 top-1/2 -translate-y-1/2 bg-pinkdarker text-white shadow-md p-2 rounded-full z-50 transition-opacity duration-300 ${canScrollLeft ? "opacity-100" : "opacity-0 pointer-events-none"
                  }`}
                aria-hidden={!canScrollLeft}
              >
                <ChevronLeft size={24} />
              </button>
              {/* Category Menu */}
              <div className="bg-white text-homeblack sticky flex top-16 z-40 shadow p-4 lg:px-10 rounded-full overflow-hidden">
                <ul
                  ref={menuRef}
                  className="flex gap-6 mx-10 w-full overflow-x-auto scroll-smooth whitespace-nowrap no-scrollbar"
                  style={{ scrollbarWidth: "none" }}
                  onScroll={checkScrollability}
                >
                  {blogs?.results?.category.map((section: any, index: number) => (
                    <a
                      key={index}
                      href={`/blog/${section?.category_slug}`}
                      className="relative cursor-pointer font-medium transition-colors duration-300 group"
                    >
                      {section?.name}
                      <span className="absolute left-0 -bottom-1 bg-pink h-[2px] w-0 group-hover:w-full transition-all duration-300"></span>
                    </a>
                  ))}
                </ul>
              </div>
              <button
                onClick={() => scrollMenu("right")}
                className={`absolute right-0 top-1/2 -translate-y-1/2 bg-pinkdarker text-white shadow-md p-2 rounded-full z-50 transition-opacity duration-300 ${canScrollRight ? "opacity-100" : "opacity-0 pointer-events-none"
                  }`}
                aria-hidden={!canScrollRight}
              >
                <ChevronRight size={24} />
              </button>
            </div>
          )}
        </div>
        <div className="w-full px-4 bg-[url('/blog/blog-inner-bg1.svg')] flex flex-col items-center -mt-1 relative h-[45vh]">
          <div className="flex min-h-[40vh] justify-center items-center w-full">

            <h1 className="text-blue text-[32px] font-bold lg:text-[48px]">W3era Blogs</h1>
          </div>
        </div>
        <div className="mx-auto py-5">
          <div className="w-full gap-5 relative h-full  mx-auto lg:w-[95%] 2xl:w-[80%] px-4 text-white mb-8 lg:mb-32">
            <div className=" w-full leading-tight rounded-lg text-textGrey mt-5 text-[18px] ">
              <div className="text-[16px]  flex items-center justify-start gap-2 flex-wrap">
                <span className="text-blue">
                  <Link href="/">Home</Link>
                </span>
                <span>
                  <MdOutlineKeyboardDoubleArrowRight />
                </span>
                <span className=" max-w-[150px] text-blue sm:max-w-[200px] lg:max-w-[250px]">
                  <Link href="/blog/">Blog</Link>
                </span>
              </div>
            </div>
            <div className="w-full ">
              <div>
                <h2 className="text-homeblack border-b-2 border-pink w-fit mt-8">Featured Blog
                </h2>
                {featured && featured.length > 0 ? (
                  <div className="flex lg:flex-row  flex-col gap-5 h-full">
                    <div className="bg-white border-[1px] group hover:bg-lightblue border-slate-200 rounded-lg my-4 lg:w-[55%] p-4 h-inherit  flex flex-col min-h-[370px]  sm:text-left items-start gap-2">
                      {featured[0]?.image && (
                        <Link href={`/blog/${featured[0]?.category?.category_slug}/${featured[0]?.slug_link}`}>
                          <Image
                            src={featured[0]?.image || ""}
                            height={275}
                            unoptimized
                            width={420}
                            alt={featured[0]?.image_alt}
                             className="w-full object-cover rounded"
                          />
                        </Link>
                      )}
                      <div className="flex flex-col ml-4 mt-16 items-start gap-2">
                        <Link href={`/blog/${featured[0]?.category?.category_slug}/${featured[0]?.slug_link}`}>
                          <p className="text-[20px] font-bold group-hover:text-blue text-homeblack  blog-title">{featured[0]?.title}</p>
                        </Link>
                        <p className="text-homegrey text-[18px]">
                          <Link href={`/blog/${featured[0]?.category?.category_slug}`}>
                            <span className="text-blue font-medium">
                              {featured[0]?.category?.name || "Uncategorized"}
                            </span>{" "}
                            |
                          </Link>
                          &nbsp;<span className="text-homegrey">{featured[0]?.blog_date || ""}</span>
                        </p>
                        <p className="text-[18px] text-textGrey blog-summary">
                          {featured[0]?.summary && featured[0]?.summary.length > 100
                            ? `${featured[0]?.summary.substring(0, 800)}...`
                            : featured[0]?.summary}
                        </p>
                        <Link href={`/blog/${featured[0]?.category?.category_slug}/${featured[0]?.slug_link}`}>
                          <button className="text-pink text-[18px] font-medium mt-auto">Read More</button>
                        </Link>
                      </div>
                    </div>
                    <div className="flex  lg:w-[45%] flex-wrap gap-4 justify-between">
                      {featured?.slice(1, 5).map((elem: any, index: number) => (
                        <div key={index} className=" w-full sm:w-[48%] ">
                          <Link href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}>
                            <div className="bg-white border-[1px] group hover:bg-lightblue border-slate-200  rounded-lg my-4 w-full  flex flex-col min-h-[370px] p-4 sm:text-left items-start gap-2">
                              {elem?.image && (
                                <Image
                                  src={elem?.image || ""}
                                  height={145}
                                  unoptimized
                                  width={328}
                                  alt={elem?.image_alt}
                                  className="w-full object-cover rounded"
                                />
                              )}
                              <div className="flex flex-col ml-4 mt-5 items-start gap-2">
                                <p className="text-[18px] group-hover:text-blue text-homeblack font-bold blog-title">
                                  {elem?.title && elem?.title.length > 30
                                    ? `${elem?.title.substring(0, 30)}...`
                                    : elem?.title}
                                </p>
                                <p className="text-homegrey text-[16px]">
                                  <Link href={`/blog/${elem?.category?.category_slug}`}>
                                    <span className="text-blue font-medium">
                                      {elem?.category?.name || "Uncategorized"}
                                    </span>{" "}
                                    |
                                  </Link>
                                  &nbsp;<span className="text-homegrey">{elem?.blog_date || ""}</span>
                                </p>
                                <button className="text-pink text-[18px] font-medium mt-auto">Read More</button>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-center items-center min-h-[400px]">
                    <div className="loader"></div>
                  </div>
                )}
              </div>
              {allBlogs.length > 0 && <div className="" ref={sectionRef}>
                <div className="border-b-2 border-pink w-fit mb-4 mt-20 text-black">
                  <h2 className="text-homeblack mb-1">Latest Blogs from W3 Era
                  </h2>
                </div>
                <div className="w-full flex justify-between flex-wrap gap-3">
                  {allBlogs.length > 0 ? (
                    allBlogs.slice(0, 6).map((elem: any, index: number) => (
                      <Link
                        href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}
                        key={index}
                        className=" w-full xl:w-[49%]"
                      >
                        <div className="bg-white group border-b-[1.5px] border-slate-200   w-full p-4 flex sm:flex-row flex-col sm:text-left items-start gap-2">
                          {elem?.image && (
                            <Image
                            unoptimized
                              src={elem?.image || ""}
                              height={175}
                              width={328}
                              alt={elem?.image_alt}
                              className="w-full sm:w-[300px] min-h-[175px] xl:min-w-[328px]"
                            />
                          )}
                          <div className="flex flex-col ml-4 items-start gap-2">
                            <p className="text-[20px] text-homeblack group-hover:text-blue font-bold blog-title">{elem?.title}</p>
                            <p className="text-homegrey text-[18px]">
                              <Link href={`/blog/${elem?.category?.category_slug}`}>
                                <span className="text-blue font-medium">{elem?.category?.name || "Uncategorized"}</span>{" "}
                                |
                              </Link>
                              &nbsp;<span className="text-homegrey">{elem?.blog_date || ""}</span>
                            </p>
                            <button className="text-pink text-[18px] font-medium">Read More</button>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <p>No blogs available.</p>
                  )}
                </div>
                <div className="flex w-full justify-center mt-3">
                  <Pagination
                    current={currentPage}
                    total={blogs?.count || 0} // Total blogs count
                    pageSize={10} // Assuming 10 blogs per page
                    onChange={handlePageChange} // Handle page change
                    showSizeChanger={false}
                  />
                </div>
              </div>}
              {blogs?.results?.youtube_video?.length > 0 && <div className="">
                <div className=" flex w-full justify-between flex-wrap   mb-4 mt-20 text-black">
                  <h2 className="text-homeblack border-b-2 border-pink mb-1">Latest W3era Videos for Digital marketing Success
                  </h2>
                  <Link href={`https://www.youtube.com/@W3eradigital`} className="lg:mt-0 mt-4" target="_blank">
                      <Button content='View All' />
                  </Link>
                </div>
                <div className="w-full flex justify-between flex-wrap gap-3">
                  {blogs?.results?.youtube_video?.length > 0 ? (
                    blogs?.results?.youtube_video?.slice(0, 4)?.map((elem: any, index: number) => (
                      <Link
                        href={elem?.url}
                        key={index}
                        className="w-full sm:w-[48%] h-full lg:w-[24%]"
                      >
                        <div className="bg-white border-[1px] group border-slate-200 rounded-lg my-4 w-full p-4 flex flex-col justify-between h-[400px]"> {/* Set a fixed height */}
                          {elem?.thumbnail && (
                            <Image
                              src={elem?.thumbnail || ""}
                              height={175}
                              unoptimized
                              width={328}
                              alt={elem?.thumbnail_alt}
                              className="w-full "
                            />
                          )}
                          <div className="flex flex-col ml-4 items-start gap-2 flex-grow"> {/* Allows the container to grow */}
                            <p className="text-[18px] text-homeblack mt-4 group-hover:text-blue font-medium blog-title">{elem?.title}</p>
                            {/* Uncomment below if you want to show category and date */}
                            {/* 
                          <p className="text-homegrey text-[18px]">
                            <Link href={`/blog/${elem?.category?.category_slug}`}>
                              <span className="text-blue font-medium">{elem?.category?.name || "Uncategorized"}</span>{" "}
                              |
                            </Link>
                            &nbsp;<span className="text-homegrey">{elem?.blog_date || ""}</span>
                          </p>
                          */}
                            {/* <button className="text-pink text-[18px] font-medium">Read More</button> */}
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <p>No blogs available.</p>
                  )}
                </div>
              </div>}
              {/* {recentblogs?.length > 0 && <div className="">
                <div className="border-b-2 border-pink w-fit mb-4 mt-20 text-black">
                  <h2 className="text-homeblack mb-1">Recent Blogs</h2>
                </div>
                <div className="w-full flex justify-between flex-wrap gap-3">
                  {recentblogs?.length > 0 ? (
                    recentblogs.slice(0, 4)?.map((elem: any, index: number) => (
                      <Link
                        href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}
                        key={index}
                        className="w-full sm:w-[48%] h-inherit lg:w-[24%]"
                      >
                        <div className="bg-white border-[1px] group border-slate-200 rounded-lg my-4 w-full p-4  sm:text-left items-start gap-2">
                          {elem?.image && (
                            <Image
                              src={elem?.image || ""}
                              height={175}
                              width={328}
                              alt={elem?.image_alt}
                              className="w-full "
                            />
                          )}
                          <div className="flex flex-col ml-4 items-start gap-2">
                            <p className="text-[20px] text-homeblack mt-4 group-hover:text-blue font-bold blog-title">{elem?.title}</p>
                            <p className="text-homegrey text-[18px]">
                              <Link href={`/blog/${elem?.category?.category_slug}`}>
                                <span className="text-blue font-medium">{elem?.category?.name || "Uncategorized"}</span>{" "}
                                |
                              </Link>
                              &nbsp;<span className="text-homegrey">{elem?.blog_date || ""}</span>
                            </p>
                            <button className="text-pink text-[18px] font-medium">Read More</button>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <p>No blogs available.</p>
                  )}
                </div>
              </div>} */}
              {category?.map((elem: any, index: number) => (
                <div key={index} className="mt-12">
                  <div className="flex items-center justify-between">

                    <div className="border-b-2 border-pink w-fit mb-4  text-black">
                      {
                        elem?.category_name == "Digital Marketing" &&
                        <h2 className="text-homeblack mb-1"> W3era Blogs:Digital Marketing Tips</h2>
                      }
                      {
                        elem?.category_name == "Google Updates" &&
                        <h2 className="text-homeblack mb-1"> W3era Blogs:Google Updates</h2>
                      }
                      {
                        elem?.category_name == "SEO" &&
                        <h2 className="text-homeblack mb-1"> W3era Blogs:Top SEO Insights</h2>
                      }
                    </div>
                    <Link href={`/blog/${elem?.category_slug}`}>
                      {/* <div
                                                                    className='flex hover:cursor-pointer text-white bg-pink hover:bg-blue hover:bg-white px-3 
                                                                    py-1 duration-200 rounded-md hover:text-pink text-nowrap  items-center text-[16px] text-blue gap-3'
                                                                    
                                                                    >View all <GoArrowRight />
                                                                </div> */}
                      <Button content='View All' />
                    </Link>
                  </div>
                  <div className="w-full flex justify-between flex-wrap gap-3">
                    {elem?.blogs?.length > 0 ? (
                      elem?.blogs.slice(0, 4).map((blog: any, blogIndex: number) => (
                        <Link
                          href={`/blog/${blog?.category?.category_slug}/${blog?.slug_link}`}
                          key={blogIndex}
                          className="w-full sm:w-[48%] h-inherit lg:w-[24%]"
                        >
                          <div className="bg-white border-[1px] group border-slate-200 rounded-lg my-4 w-full p-4 sm:text-left items-start gap-2 flex flex-col h-full">
                            {blog?.image && (
                              <Image
                                src={blog?.image || ""}
                                height={175}
                                
                                width={328}
                                unoptimized
                                alt={blog?.image_alt || "Blog Image"}
                                className="w-full"
                              />
                            )}
                            <div className="flex flex-col ml-4 items-start gap-2">
                              <p className="text-[20px] text-homeblack mt-4 group-hover:text-blue font-bold blog-title">
                                {blog?.title}
                              </p>
                              <p className="text-homegrey text-[18px]">
                                <Link href={`/blog/${blog?.category?.category_slug}`}>
                                  <span className="text-blue font-medium">
                                    {blog?.category?.name || "Uncategorized"}
                                  </span>{" "}
                                  |
                                </Link>
                                &nbsp;<span className="text-homegrey">{blog?.blog_date || ""}</span>
                              </p>
                              <button className="text-pink text-[18px] font-medium">Read More</button>
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <p>No blogs available.</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <NewsLetter />
        </div>
      </div>
    </div>
  )
}

export default Blogs

